import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../shared/context/AuthContext';
import { getHomePath } from '../shared/utils/homePath';
import { passesRoleGate } from '../shared/utils/roles';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
}

export function RoleProtectedRoute({ children, allowedRoles }: RoleProtectedRouteProps) {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const userRole = user?.role?.toLowerCase();
  const hasAccess = passesRoleGate(userRole, allowedRoles);

  if (!hasAccess) {
    return <Navigate to={getHomePath(userRole)} replace />;
  }

  return <>{children}</>;
}
